(function () {

  'use strict';

  function pxSynchronizeGroupsRow() {
    return {
      restrict: 'E',
      // scope:true so the directive inherits idp/descriptor/openContextMenu/
      // synchronizeGroups/closeAllMenues/me from the host card scope (where
      // IdpContextMenuMixin.attach was called) but can attach its own helpers
      // without polluting the parent. Directories arrive in the canonical
      // wrapped shape ({ name, unConnected, info, groupSyncState }) produced
      // by IdpProviderService.directoriesFor — the row reads groupSyncState
      // directly and does not interpret links.
      scope: true,
      templateUrl: 'app/components/authenticationSettings/_synchronizeGroupsRow/synchronizeGroupsRow.template.html',
      link: function (scope) {

        scope.syncRow = {};

        // SCIM_AVAILABLE: open the multi-step onboarding wizard. If the
        // directory also carries px:enable_groups, the wizard starts at the
        // sync-method step so the admin can still pick API; otherwise it
        // jumps straight to the auth-method step.
        scope.syncRow.startOnboarding = function (event) {
          const links = (scope.idp && scope.idp.info && scope.idp.info._links) || {};
          const hasApi = !!links['px:enable_groups'];
          const enableScimLink = links['px:enable_scim_provisioning'];
          const context = {
            idp: scope.idp,
            descriptor: scope.descriptor,
            name: hasApi ? 'GroupSynchronization' : 'GroupSynchronizationWithSCIM',
            step: hasApi ? 'syncMethod' : 'authMethod',
            enableScimUrl: enableScimLink ? enableScimLink.href : null,
            hasApiSync: hasApi,
            authType: null,
            payload: null,
            acceptApiSync() {
              if (angular.isFunction(scope.closeAllMenues)) {
                scope.closeAllMenues();
              }
              if (angular.isFunction(scope.synchronizeGroups)) {
                scope.synchronizeGroups(scope.idp);
              }
            }
          };
          const menuOption = {
            bypassCloseOutside: true,
            type: 'synchronizeGroups',
            title: 'GroupSynchronization'
          };
          scope.openContextMenu(event, context, menuOption);
        };

        // SCIM_ENABLED: open the disable form. The form DELETEs the
        // px:scim_provisioning URL.
        scope.syncRow.startDisable = function (event) {
          const scimLink = ((scope.idp && scope.idp.info && scope.idp.info._links) || {})['px:scim_provisioning'];
          const context = {
            idp: scope.idp,
            descriptor: scope.descriptor,
            name: 'ResetScimGroupSynchronization',
            scimUrl: scimLink ? scimLink.href : null
          };
          const menuOption = {
            bypassCloseOutside: true,
            type: 'scimDisable',
            title: 'Modify'
          };
          scope.openContextMenu(event, context, menuOption);
        };

        // LEGACY_AVAILABLE: there is no SCIM offered, just the permanent
        // px:enable_groups action link. Call straight through to the host's
        // synchronizeGroups (OAuth consent popup); the websocket-driven
        // groups_enabled flip handles post-success state.
        scope.syncRow.runLegacyAction = function () {
          if (angular.isFunction(scope.closeAllMenues)) {
            scope.closeAllMenues();
          }
          if (angular.isFunction(scope.synchronizeGroups)) {
            scope.synchronizeGroups(scope.idp);
          }
        };

        // LEGACY_ENABLED → "Setup SCIM provisioning": legacy stays as-is, the
        // wizard opens straight at authMethod since the admin's intent is to
        // add SCIM, not pick afresh between API and SCIM.
        scope.syncRow.startLegacyModify = function (event) {
          const enableScimLink = scope.idp?.info?._links?.['px:enable_scim_provisioning'];
          const context = {
            idp: scope.idp,
            descriptor: scope.descriptor,
            name: 'GroupSynchronization',
            step: 'authMethod',
            enableScimUrl: enableScimLink ? enableScimLink.href : null,
            hasApiSync: false,
            authType: null,
            payload: null
          };
          const menuOption = {
            bypassCloseOutside: true,
            type: 'synchronizeGroups',
            title: 'GroupSynchronization'
          };
          scope.openContextMenu(event, context, menuOption);
        };
      }
    };
  }

  pxSynchronizeGroupsRow.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxSynchronizeGroupsRow', pxSynchronizeGroupsRow);

})();
